import { WidgetSelector as WidgetSelectorDSOB } from '@clevercraft/distribution-sob'
import { FilterKeys } from 'legacy/lut/classes/models/onboarding/FilterKeys'
import { OnbPageURLs, RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { useHistoryCompatible } from 'legacy/lut/components/widgets/hooks/useHistoryCompatible'

import { PARTNER_WIDGET_LOADING_HEIGHT, WidgetName } from 'clickNgo/features/widgets'
import { WidgetLazyRenderer } from 'clickNgo/features/widgets/components'
import {
  lazyRenderWidgetByLoader,
  projectLoaders,
  TWidgetLoadFunction,
} from 'core-components/helpers/lazyLoad'
import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'
import {
  WIDGET_EPI_CODES_VIEW,
  WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_SETTINGS,
  WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_VIEW,
} from 'onboarding/constants'
import { WidgetSelector as WidgetSelectorDef } from 'search/components/widgets/WidgetSelector'
import { SectionLoadingFrame } from 'shared/components/sectionLoading'

import { WidgetSelectorOnboarding } from './WidgetSelectorOnboarding'
import { WidgetSelectorPartner360 } from './WidgetSelectorPartner360'

const getLutComponents = async (name: string) => {
  const layoutName = name.split('/').at(-1)

  return import(`legacy/lut/components/layout/${layoutName}.tsx`)
}

projectLoaders['legacy/lut/'] = getLutComponents as unknown as TWidgetLoadFunction

// projectLoaders['onboarding/'] = (name: string, key: string) =>
//   import('onboarding/' + name.replace(key, ''))
// projectLoaders['legacy/lut/'] = (name: string, key: string) => import('legacy/lut/' + name.replace(key, ''))
// projectLoaders['clickNgo/'] = (name: string, key: string) =>
//   import('clickNgo/' + name.replace(key, ''))

export const WidgetSelector = (props: IWidgetSelector) => {
  useHistoryCompatible()

  if (props.viewModel === 'partner-status-hpscoutso') {
    const dependencies = [WidgetName.PartnerDashboardPanel]
    return (
      <WidgetLazyRenderer
        id={props.viewModel}
        dependencies={dependencies}
        loader={() => import('legacy/lut/components/widgets/public/partnerStatus/PartnerStatus')}
        hasLoaderPlug
        loaderPlug={<SectionLoadingFrame show minHeight={PARTNER_WIDGET_LOADING_HEIGHT} />}
        loadMeta={true}
        props={props.props}
      />
    )
  }

  if (
    props.viewModel === 'contracts-hpscoutso-43087044' ||
    props.viewModel === 'contracts-lut-37534088'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/Contracts'),
      props: {
        ...props.props,
        PartnerID: props.props.pid || props.props.widgetParams.PartnerProId,
      },
      loadMeta: true,
    })
  }
  if (
    props.viewModel === 'new-partners-lut-57799335' ||
    props.viewModel === 'new-partners-requests'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/NewPartners'),
      props: props.props,
    })
  }

  if (props.viewModel === 'profiling-partners-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partnerHierarchy/PartnerHierarchy'),
      props: { ...props.props, onlyOpened: true },
    })
  }

  if (props.viewModel === 'tab-buttons-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/TabButtons'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (
    props.viewModel === 'tab-buttons-lut-5012923' ||
    props.viewModel === 'tab-buttons-tm-31243143'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/TabButtons'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'tab-buttons-lut-43534') {
    const dependencies = [WidgetName.PartnerDashboardPanel]
    return (
      <WidgetLazyRenderer
        dependencies={dependencies}
        id={props.viewModel}
        props={props.props}
        loader={() => import('legacy/lut/components/widgets/public/TabButtons')}
        loadMeta={true}
        hasLoaderPlug
      />
    )
  }

  if (props.viewModel === 'new-contacts-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ContactData'),
      props: { ...props.props, onlyOpened: true, defaultShowNew: true, onlyMine: true },
    })
  }

  if (props.viewModel === 'excel-map-creator') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/library/list/excel/MappingCreator'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'excell-loader') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/library/list/excel/ExcelLoader'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'user-excel-loader') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/library/list/excel/ExcelLoader'),
      props: {
        ...props.props,
        mappingId: '10',
      },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'edited-contacts-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ContactData'),
      props: { ...props.props, onlyOpened: true },
    })
  }

  if (props.viewModel === 'my-partner-list-csi-filtered-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/MyPartnerListCSIFiltered'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'my-partner-list-csi-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/campaignList/MyPartnerListCampaign'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-dashboard-widget') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partnerDashboardSelector/PartnerDashboardSelector'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'comment-management-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/CommentManagement'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'shares-of-business-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/SharesOfBusiness'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'static-maintenance') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('partner360/widgets/staticMaintenance/StaticMaintenance'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'maintenance-widget') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/MaintenanceWidget/MaintenanceWidget'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'preferred-distributors-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/PreferredDistributors'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-landscape-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/PartnerLandscape'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'swot-analysis-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/SwotAnalysis'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'registrations-data-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/RegistrationData'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'registrations-data-lut-new') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/RegistrationsDataNew'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'reconfirmations-data-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpReconfirmation/detailedList/WidgetBPReconfirmationData'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetBusinessProfile') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partnerContacts/PartnerContacts'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'contacts-data-display-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partnerContacts/PartnerContacts'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'cng-partner-contacts') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerContacts'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-selector-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/Partner360DashboardSelector'),
      props: { ...props.props, widgetProps: props.props },
    })
  }

  if (props.viewModel === 'WidgetCallOutList') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/CallOutList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetPricingList') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/PricingList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetBPOverview') {
    const dependencies = [WidgetName.PartnerDashboardPanel]
    return (
      <WidgetLazyRenderer
        id={props.viewModel}
        loader={() =>
          import('clickNgo/widgets/bpOverview/BPOverview').then((m) => ({ default: m.BPOverview }))
        }
        props={props.props}
        dependencies={dependencies}
        hasLoaderPlug
        loaderPlug={<SectionLoadingFrame show minHeight={PARTNER_WIDGET_LOADING_HEIGHT} />}
      />
    )
  }

  if (props.viewModel === 'WidgetPartnerDetails') {
    const dependencies = [WidgetName.PartnerDashboardPanel]
    const excludedPages = ['p360']
    return (
      <WidgetLazyRenderer
        id={props.viewModel}
        loader={() => import('clickNgo/widgets/partnerDetails/PartnerDetails')}
        props={props.props}
        dependencies={dependencies}
        excludedPages={excludedPages}
        hasLoaderPlug
        loaderPlug={<SectionLoadingFrame show minHeight={PARTNER_WIDGET_LOADING_HEIGHT} />}
        loadMeta={true}
      />
    )
  }

  if (props.viewModel === 'WidgetPreferredContacts') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/preferredContacts/PreferredContacts'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetToDo') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ToDo'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetMyPartnerSet') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/MyPartnerSet'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'cNg-my-partners') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/myPartners/MyPartners'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'partner-data') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partnerHierarchy/PartnerHierarchy'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'WidgetProductCard') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/promotions/ProductCard'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetPromotionsContent') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/promotions/PromotionsContent'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetPromotionsControl') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/promotions/PromotionsControl'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'WidgetPartnerReward') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/partnerReward/Reward'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'partneradditional-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/PartnerAdditionalInfo'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'opened-requests-lut-41742900') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/OpenedRequests'),
      props: { ...props.props },
    })
  }

  if (
    props.viewModel === 'userrightsearchcontacts-lut' ||
    props.viewModel === 'userrightsearchcontacts-hpscoutso'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/UserRightSearchContacts'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'campaigndescription-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/myPartnerListCSI/CampaignDescription'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'descriptionwrapper-hpscoutso') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/myPartnerListCSI/CampaignDescriptionWrapper'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'campaign-edit-negotiable-reason') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/myPartnerListCSI/CampaignEditNegotiableReason'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'flags-admin-lut-39740031') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/flagManagement'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'country-province-lut') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/CountryProvince'),
      props: { ...props.props },
    })
  }

  if (
    props.viewModel === 'country-management' ||
    props.viewModel === 'country-management-lut' ||
    props.viewModel === 'country-management-hpscoutso'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/CountryManagement'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'lut-chat-widget' || props.viewModel === 'lut-reversed-chat-widget') {
    const commentSource = (props.props.customSettings as IObjectAny)?.commentSource || ''
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/shared/LutChatWidget'),
      props: {
        ...props.props,
        isReversedChat: props.viewModel === 'lut-reversed-chat-widget',
        commentSource,
        urlKey: props.props.urlKey,
      },
      loadMeta: true,
    })
  }

  if (
    props.viewModel === 'registration-comments-lut' ||
    props.viewModel === 'comments-activation' ||
    props.viewModel === 'comments--business-profile-lut' ||
    props.viewModel === 'comments-mycoverage-lut' ||
    props.viewModel === 'comments-mydashboards-lut' ||
    props.viewModel === 'mydashboard-comments-lut' ||
    props.viewModel === 'comments-activities-lut' ||
    props.viewModel === 'campaign-description-comments' ||
    props.viewModel === 'my-tasks-lut-35903151' ||
    props.viewModel === 'pricing-comments' ||
    props.viewModel === 'comments--business-development-lut' ||
    props.viewModel === 'swot-comments-lut-48814166' ||
    props.viewModel === 'Registration Comments React Widget' ||
    props.viewModel === 'comment-report-lut-22693467' ||
    props.viewModel === 'comments--opg-promotion-lut' ||
    props.viewModel === 'article-comments-lut' ||
    props.viewModel === 'comments--postsales-lut'
  ) {
    const commentSource = (props.props.customSettings as IObjectAny)?.commentSource || ''
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('core/sitebuilder/widgets/ChatWidget'),
      props: { ...props.props, commentSource },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-search-form') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchForm/SearchForm'),
      props: { ...props.props, isStateVisible: true, isStoreNumberVisible: true },
    })
  }

  if (props.viewModel === 'partner-search-results') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/searchResult/SearchResults'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'widget-legal-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partnerHierarchy/PartnerHierarchy'),
      props: { ...props.props, onlyLegal: true },
    })
  }

  if (props.viewModel === 'widget-pf-eligibility') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/pfEligibility/WidgetPFEligibility'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'partner-program-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/requestsDashboard/OpenPartnerFlagsRequests'),
      props: { ...props.props, type: 'Program' },
    })
  }

  if (props.viewModel === 'partner-accreditation-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/requestsDashboard/OpenPartnerFlagsRequests'),
      props: { ...props.props, type: 'Accreditation' },
    })
  }

  if (props.viewModel === 'contact-userrights-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/requestsDashboard/OpenContactCodesRequests'),
      props: { ...props.props, type: 'UserRights' },
    })
  }

  if (props.viewModel === 'contact-campaigns-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/requestsDashboard/OpenContactCodesRequests'),
      props: { ...props.props, type: 'Campaigns' },
    })
  }

  if (props.viewModel === 'contact-tools-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/requestsDashboard/OpenContactCodesRequests'),
      props: { ...props.props, type: 'Tools' },
    })
  }

  if (props.viewModel === 'campaigns-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/campaignAdmin/CampaignsList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'campaigns-admin-widget') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/campaignAdmin/CampaignsAdminWidget'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'bpregistration-status-check') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/registrationsData/BPRegistrationStatusCheck'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'bpregistration-status-check-new') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/registrationsData/BPRegistrationStatusCheckNew'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'campaign-description-admin') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/campaignAdmin/CampaignDescriptionAdmin'),
      props: { ...props.props, campaign: props.props.campaign },
    })
  }

  if (
    props.viewModel === 'validation-rules-lut' ||
    props.viewModel === 'validation-rules-hpscoutso'
  ) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ValidationRules'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'request-templates') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/templates/RequestTemplates'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-template-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/templates/requestTemplates/TemplateDetail'
        ),
      props: { ...props.props, metrics: props.props.metrics, requestUUID: props.props.uuid },
    })
  }
  if (props.viewModel === 'action-templates') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/templates/ActionTemplates'),
      props: { ...props.props, metrics: props.props.metrics, requestUUID: props.props.uuid },
    })
  }
  if (props.viewModel === 'action-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/templates/actionDetail/ActionDetail'
        ),
      props: {
        ...props.props,
        metrics: props.props.metrics,
        aid: props.props.aid,
        parid: props.props.parid,
        requestUUID: props.props.uuid,
      },
    })
  }
  if (props.viewModel === 'action-expiration-timer') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/actionExpirationTimer/ActionExpirationTimer'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'information-section') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/InformationSection/InformationSection'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'import-request-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/uploadHistoryTable/ImportRequestHistory'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'import-apl-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin/uploadHistoryTable/ImportAPLHistory'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'import-apl-ams-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin/uploadHistoryTable/ImportAPLAMSHistory'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'apl-report-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin/uploadHistoryTable/APLReportHistory'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'bp-dormant-report-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/uploadHistoryTable/BPDormantReportHistory'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestList'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-list-onb') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestList'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-list-retail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestList'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'bp-reconfirmations') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestList'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'retail-registration') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/retailRegistration/retailRegistration'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_SETTINGS) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/eligibilityCriteria/settings/EligibilityCriteriaSettings'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_VIEW) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/eligibilityCriteria/viewAllCriteria/widget/ViewAllCriteriaWidget'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === WIDGET_EPI_CODES_VIEW) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/epiCodes/EpiCodesPanel'),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'active-bp-reports') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin/activeBPReports/ActiveBPReports'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'onboarding-retail-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/retailRegistration/OnboardingRetail'
        ),
      props: { ...props.props, rid: props.props.rid },
    })
  }
  if (props.viewModel === 'onboarding-hybrid-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/retailRegistration/OnboardingHybrid'
        ),
      props: { ...props.props, rid: props.props.rid },
    })
  }
  if (props.viewModel === 'new-request') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/NewRequest'),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'action-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/ActionList'
        ),
      props: {
        ...props.props,
        rid: props.props.rid,
        flexWidth: props.props.flexWidth,
        metrics: props.props.metrics,
        aid: props.props.aid,
      },
    })
  }
  if (props.viewModel === 'request-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestDetail'),
      props: { ...props.props, rid: Number(props.props.rid) },
    })
  }
  if (props.viewModel === 'onboarding-request-files') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/filesTable/FilesTable'
        ),
      props: { ...props.props, metrics: props.props.metrics, rid: props.props.rid },
    })
  }
  if (props.viewModel === 'onboarding-request-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/HistoryTimeline'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-chart') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/processGraph/ProcessDiagramWidgetWrapper'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'user-mapping-onb') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/userMapping/UserMapping'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'request-for-partner') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/onboarding/requestList/OnboardingRequestList'
        ),
      props: { ...props.props, Type: RequestTypes.Onboarding },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'exception-requests-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/exceptions/ExceptionRequestList'
        ),
      props: {
        ...props.props,
        type: RequestTypes.Exception,
        localFiltersKey: FilterKeys.ExceptionRequests,
        partnerId: props.props.pid,
      },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'onb-notification-templates') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/templates/notifications/NotificationTemplates'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'contacts-list-admin') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/admin/contracts/ContractAdmin'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'onb-request-notifications') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestNotifications'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'onb-req-notification-detail') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestNotificationDetail'
        ),
      props: { ...props.props, metrics: props.props.metrics, campaignId: props.props.campId },
    })
  }
  if (props.viewModel === 'specializations-admin') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin/specializations/SpecializationsAdmin'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'expiration-dates') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/Admin/ActionsExpirations'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'onb-req-forms') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/RequestForms'),
      props: {
        ...props.props,
        metrics: props.props.metrics,
        rid: props.props.rid,
        flexWidth: props.props.flexWidth,
      },
    })
  }
  if (props.viewModel === 'checked-actions-chart') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/autoCheck/CheckedActionsChart'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'time-per-action-chart') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/autoCheck/TimePerActionChart'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'total-check-time') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/autoCheck/TotalCheckTimeChart'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'autocheck-stats') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/autoCheck/AutoCheckStats'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'exceptions-admin') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/admin//exceptionsReasons/ExceptionsAdmin'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'onb-upload') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/OnboardingUpload'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'apl-import') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/admin/importList/ImportAPL'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'apl-ams-import') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/admin/importList/ImportAPLAms'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'non-eligible-partner-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'onboarding/components/widgets/public/admin/importList/ImportNonEligiblePartnerList'
        ),
      props: { ...props.props },
    })
  }

  // Unified upload widgets (onboarding/modules/upload). Type/filter is set per
  // placement via static props (uploadType / uploadTypes) — see module getMetaInfo.
  // loadMeta + the forwarded getMetaInfo are required for those static props to register.
  if (props.viewModel === 'onboarding-upload') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/modules/upload').then((m) => ({
          default: m.UploadWidget,
          getMetaInfo: m.getMetaInfo,
        })),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'onboarding-upload-history') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/modules/upload').then((m) => ({
          default: m.UploadHistoryWidget,
          getMetaInfo: m.getMetaInfo,
        })),
      props: { ...props.props },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'onboarding-upload-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/modules/upload').then((m) => ({
          default: m.UploadPanel,
          getMetaInfo: m.getMetaInfo,
        })),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'my-actions') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/onboarding/myActions/MyActions'),
      props: { ...props.props, flexWidth: props.props.flexWidth, metrics: props.props.metrics },
    })
  }
  if (props.viewModel === 'roles-mapping') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/components/widgets/public/rolesMapping/RolesMapping'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'partner-exclusion-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('onboarding/components/widgets/public/partnerExclusion/PartnerExclusionList'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'partner-requests-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/PartnerRequestsList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'creation-partner-request') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/CreationPartnerRequest'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'contact-requests-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/ContactRequestsList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'requests-navigation') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/requestNavigation/RequestNavigationTab'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'creation-contact-request') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/CreationContactRequest'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'change-partners-request') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/ChangePartnerRequest'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'change-contact-request') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/profilingTeam/ChangeContactRequest'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'hp-amplify-impact-summary') {
    const dependencies = [WidgetName.PartnerDashboardPanel]
    return (
      <WidgetLazyRenderer
        id={props.viewModel}
        loader={() =>
          import('legacy/lut/components/widgets/public/amplifyImpact/AmplifyImpact').then((m) => ({
            default: m.AmplifyImpact,
          }))
        }
        props={props.props}
        dependencies={dependencies}
        hasLoaderPlug
        loaderPlug={<SectionLoadingFrame show minHeight={PARTNER_WIDGET_LOADING_HEIGHT} />}
      />
    )
  }

  if (props.viewModel === 'sustainability-breadcrumbs') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/sustainability/ImpactSustainabilityBreadcrumbs'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'sales-team-tabs') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/salesTeam/SalesTeam'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'amplify-insight-requests') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/amplifyInsightRequests/AmplifyInsight'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'AmplifyInsightPartner') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/amplifyInsightRequests/AmplifyInsigthPartner'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'error-action') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/onboarding/Admin/ErrorActions'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'profiling-tickets-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ProfilingTicketsTable'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'sales-team-requests-view') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/salesTeamRequestsView/SalesTeamRequestsView'),
      props: { ...props.props, ticketId: props.props.ticketId },
    })
  }

  if (props.viewModel === 'profiling-ticket-view') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('legacy/lut/components/widgets/public/ProfilingTicketView'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'bp-reconfirmation') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpReconfirmation/ReconfirmationWrapper'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'bp-registration') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpRegistration/BPRegistrationWrapper'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'simple-partner-registration') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/aplRegistration/APLWrapper'),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'terms-and-conditions') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpRegistration/steps/termsAndConditions/TermsAndConditionsPage'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === OnbPageURLs.DistributorOnBehalfUpdate) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpRegistration/steps/distributorsOnBehalf/DistributorsOnBehalfPage'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'bp-broken-regs-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/onboarding/bpRegistration/brokenRegs/BPBrokenRegsList'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'backup-users') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/Admin/backupUsers/BackupUsersList'),
      props: { ...props.props },
    })
  }

  // Business opportunity finder
  if (props.viewModel === 'business-opportunity-finder-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/BusinessOpportunityFinderTable/BusinessOpportunityFinderTable'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'partners-by-market-summary-table') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/PartnersByMarketSummaryTable/PartnersByMarketSummaryTable'
        ),
      props: { ...props.props },
    })
  }
  if (props.viewModel === 'jbp-partner-scope-management') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/partnerScopeManagement/table/PartnerScopeManagementTable'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'jbp-elt-form') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/ELT/ui/eltForm/EltForm'),
      props: {
        ...props.props,
        partnerId: props.props.pid,
        versionId: props.props.vid,
        urlParameterForGroupVersions: props.props.vgp,
        urlParameterForPartnerVersions: props.props.vp,
      },
      loadMeta: true,
    })
  }
  if (props.viewModel === 'jbp-elt-guidlines') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/ELT/ui/guidelines/GuideLinesSeparatePage'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'jbp-elt-search') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/partner360/ELT/ui/eltSearch/EltSearch'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'c&g-user-list') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/userList/UserList'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'c&g-user-details') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/userDetails/UserDetails'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'jbp-group-management') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/partner360/managePartnerGroups/ui/groupManager/groupList/GroupList'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'create-partner') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/createPartner/CreatePartner'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'partner-dashboard-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerDashboardPanel/PartnerDashboardPanel'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-exception') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerException/PartnerException'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'static-notification') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/staticNotification/StaticNotification'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'notification-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/notificationPanel'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'cng-promotions') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/promotions'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'md-reassignment') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/widgets/masterDealer').then((m) => ({ default: m.EPReassignment })),
      props: { metrics: props.props.metrics },
    })
  }

  if (props.viewModel === 'master-dealer-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('partner360/widgets/masterDealer').then((m) => ({ default: m.MDReport })),
      props: { metrics: props.props.metrics },
    })
  }

  if (props.viewModel === 'lnr-report') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/lnrReport/LNRReport'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-changelog') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerChangelog/PartnerChangelog'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'partner-search') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerSearch/PartnerSearch'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'partner-dashboard') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/partnerDashboard'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'campaigns') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/campaigns'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'amp-poe-download-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/AmpPoeFormDownloadPanel/AmpPoeFormDownloadPanel'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'order-management-ids') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/orderManagement/OrderManagementIDs'),
      props: props.props,
    })
  }

  if (props.viewModel === 'profitabilityToolTable') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/ProfitabilityToolTable/ProfitabilityToolTable'
        ),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'redirect-countdown-panel') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import(
          'legacy/lut/components/widgets/public/redirectCountdownPanel/RedirectCountdownPanel'
        ),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'mdm-autoflagging-rules') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/mdmAutoflaggingRules'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'flag-management') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/widgets/flagManagement'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'sandbox-key-initiatives') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('clickNgo/sandbox/sandboxKeyInitiatives'),
      props: { ...props.props },
    })
  }

  return (
    WidgetSelectorOnboarding({ ...props }) ||
    WidgetSelectorPartner360({ ...props }) ||
    WidgetSelectorDSOB(props) || <WidgetSelectorDef {...props} />
  )
}
